export const socialsData = {
    github: 'https://github.com/Abhishek-Choubey',
    // facebook: 'https://www.facebook.com/',
    linkedIn: 'https://www.linkedin.com/in/abhishek-choubey-b060a9171/',
    instagram: 'https://www.instagram.com/accounts/login/?next=/alphaabhi111/',
    codepen: 'https://codepen.io/abhishek-choubey',
    // twitter: 'https://twitter.com/',
    // reddit: 'https://www.reddit.com/user/',
    // blogger: 'https://www.blogger.com/blog/posts/8742965067410800604',
    // medium: 'https://medium.com/@achoubey463',
    stackOverflow: 'https://stackoverflow.com/users/16897259/abhishek-choubey',
    // gitlab: 'https://gitlab.com/',
    // youtube: 'https://youtube.com/'
}